/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compound Interest Calculator`)
};

const es_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Interés Compuesto`)
};

const de_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zinseszinsrechner`)
};

const nl_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculator voor samengestelde rente`)
};

const fr_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'intérêt composé`)
};

const it_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'Interesse Composto`)
};

const pt_br2_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Juros Compostos`)
};

const pt_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Juros Compostos`)
};

const ja_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利計算ツール`)
};

const zh_cp_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_nav_main", locale)
	if (locale === "en") return en_cp_nav_main(inputs)
	if (locale === "es") return es_cp_nav_main(inputs)
	if (locale === "de") return de_cp_nav_main(inputs)
	if (locale === "nl") return nl_cp_nav_main(inputs)
	if (locale === "fr") return fr_cp_nav_main(inputs)
	if (locale === "it") return it_cp_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_cp_nav_main(inputs)
	if (locale === "pt") return pt_cp_nav_main(inputs)
	if (locale === "ja") return ja_cp_nav_main(inputs)
	return zh_cp_nav_main(inputs)
};